<template>
    <div class="street-view" ref="streetview">
        <a href="#" @click.prevent="setupStreetview">
            <img :src="static">
            <span class="btn btn-yellow">
                <i class="fa fa-hand-pointer-o"/>
                Interactive streetview
            </span>
        </a>
    </div>
</template>

<script>
    import GoogleService from '../../modules/GoogleService';

    export default {
        name: 'space-streetview',

        props: ['lat', 'lng', 'heading', 'pitch', 'static'],

        data() {
            return {
                streetview: null,
            }
        },

        computed: {
            latLng() {
                return new google.maps.LatLng(
                    parseFloat(this.lat),
                    parseFloat(this.lng)
                );
            },
        },

        mounted() {
            ['lat', 'lng', 'heading', 'pitch'].forEach((key) => {
                this.$watch(key, this.setPosition);
            });
        },

        methods: {
            /**
             * Update the streetview position
             */
            setPosition() {
                this.streetview.setPosition(this.latLng);

                this.streetview.setPov({
                    heading: this.heading,
                    pitch: this.pitch,
                });
            },

            /**
             * Init the streetview
             */
            setupStreetview() {
                GoogleService.loadMapsApi().then(({ StreetViewPanorama }) => {
                    this.streetview = new StreetViewPanorama(this.$el, {
                        position: this.latLng,
                        scrollwheel: false,
                        fullscreenControl: false,
                        addressControl: false,
                        zoomControl: false,
                        showRoadLabels: false,
                        pov: {
                            heading: this.heading,
                            pitch: this.pitch,
                        },
                    });
                });
            },
        },
    }
</script>

<style lang="less" scoped>
    @import (less) "~assets/less/variables";

    .street-view {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        img {
            width: 100%;
            height: 100%;
        }
        span.btn {
            position: absolute;
            bottom: 10px;
            left: 50%;
            font-family: @headings-font-family;
            font-weight: 600;
            margin-left: -100px;
        }
    }
</style>
